export const ClientType = {
    normal: "normal",
    embed: "embed",
    splash: "splash",
    mobile: "mobile",
    calendar: "calendar",
    cards: "cards",
    facebook:"facebook"
}


// WEBPACK FOOTER //
// ./src/Apps/shared/ClientHost/type.ts